import { Component, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolsService } from '../../../sb-editor-tools/services/tools.service';
import { VersionService } from '../../services/version.service';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss']
})
export class VersionComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  public panosversion = null;
  constructor(private toolsService: ToolsService, private versionService: VersionService) {

  }

  ngOnInit(): void {
    this.subscriptions = [];
    const ms$ = this.versionService.getMinisiteConfigAsync$().subscribe(res=>{
      this.panosversion = res.set_id;
    });
    this.subscriptions.push(ms$)
  }
  
  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe())
  }

}
